import { useQuery } from "@tanstack/react-query";
import { getDbName } from "../api";

export default function useDbName() {
  const { data, error } = useQuery({
    queryKey: ["dbName"],
    queryFn: async () => {
      const res = await getDbName();
      return res;
    },
    onError: (error) => {
      console.error("Error fetching db name:", error);
    }
  });

  return data;
}
